export default "__VITE_PUBLIC_ASSET__b881be43__"